import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonografieComponent } from './monografie.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [MonografieComponent],
  exports:[MonografieComponent]
})
export class MonografieModule { }
